import { reactive } from 'vue'

export const store = reactive({
  data: {},
  put (hash) {
    this.data = hash
  },
  get () {
    return this.data
  }
})
